function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m31.628 257.94c0-66.123 29.008-126.361 74.917-168.04-.455-.392-.906-.79-1.337-1.221l-21.766-21.764c-2.87 2.618-5.696 5.3-8.462 8.066-48.351 48.351-74.98 112.638-74.98 181.018v84.774l4.474 5.368h27.154z",
  fill: "#dbedff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.454 255.999c0-68.38 26.628-132.667 74.98-181.019.013-.012.025-.024.037-.036l-8.029-8.029c-2.87 2.618-5.696 5.3-8.462 8.066-48.351 48.351-74.98 112.638-74.98 181.018v84.774l4.474 5.368h16.454l-4.474-5.368z",
  fill: "#b5dcff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m437.02 74.981c-2.766-2.766-5.592-5.448-8.462-8.066l-21.765 21.765c-.235.234-.486.442-.728.665 45.595 41.097 74.308 100.583 74.308 166.654v90.143h25.032l6.596-5.368v-84.774c-.001-68.381-26.629-132.668-74.981-181.019z",
  fill: "#dbedff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m437.02 74.981c-2.766-2.766-5.592-5.448-8.462-8.066l-21.765 21.765c-.235.234-.486.442-.728.665 45.595 41.097 74.308 100.583 74.308 166.654v90.143h25.032l6.596-5.368v-84.774c-.001-68.381-26.629-132.668-74.981-181.019z",
  fill: "#dbedff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m497.384 346.142v-90.143c0-63.228-26.295-120.426-68.517-161.249-3.116-3.013-3.119-8.01-.055-11.075 1.974-1.974 4.695-4.697 8.447-8.45-.081-.081-.158-.164-.239-.245-2.766-2.766-5.592-5.448-8.462-8.066l-21.765 21.766c-.235.234-.486.442-.728.665 45.595 41.097 74.308 100.583 74.308 166.654v90.143z",
  fill: "#b5dcff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m480.372 340.773-4.328 3.308v58.893l4.328 4.762c17.468 0 31.628-14.16 31.628-31.628v-35.334h-31.628z",
  fill: "#a5afe7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m497.384 340.773h-17.012l-4.328 3.308v58.893l4.328 4.762c6.264 0 12.098-1.829 17.012-4.971z",
  fill: "#8896e0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31.628 340.773h-31.628v35.334c0 17.468 14.16 31.628 31.628 31.628l6.757-4.075v-57.519z",
  fill: "#8896e0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.454 376.108v-35.334h-16.454v35.334c0 17.468 14.16 31.628 31.628 31.628l4.13-2.491c-11.345-4.805-19.304-16.041-19.304-29.137z",
  fill: "#6b7ed9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256 0c-64.469 0-125.295 23.679-172.564 66.908l21.771 21.771c8.4 8.4 21.645 9.39 31.254 2.405 33.6-24.426 74.914-38.853 119.539-38.853s85.938 14.427 119.539 38.853c9.609 6.985 22.854 5.995 31.254-2.405l21.771-21.771c-47.269-43.229-108.095-66.908-172.564-66.908z",
  fill: "#ff636e"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m156.868 52.558c37.026-28.414 80.772-45.963 127.279-51.024-9.284-1.009-18.674-1.534-28.147-1.534-64.469 0-125.295 23.679-172.564 66.909l21.771 21.771c8.4 8.4 21.645 9.39 31.254 2.405 5.396-3.923 10.994-7.584 16.77-10.973-6.48-8.478-5.085-20.86 3.637-27.554z",
  fill: "#ff4654"
})), /*#__PURE__*/React.createElement("path", {
  d: "m458.322 300.288h-16.049l-5.892 9.797v174.617l5.892 6.205h16.049c12.127 0 22.05-9.922 22.05-22.05v-146.519c0-12.128-9.922-22.05-22.05-22.05z",
  fill: "#6b7ed9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m69.727 300.288h-16.049c-12.127 0-22.05 9.922-22.05 22.05v146.519c0 12.128 9.922 22.05 22.05 22.05h16.049l8.493-5.432v-176.935z",
  fill: "#6b7ed9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m464.313 301.142c-1.909-.543-3.914-.854-5.99-.854h-16.049l-5.892 9.797v174.617l5.892 6.205h16.049c2.077 0 4.082-.311 5.99-.854z",
  fill: "#4d66d2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m54.924 468.857v-146.519c0-9.944 6.674-18.394 15.761-21.119l-.958-.931h-16.049c-12.127 0-22.05 9.922-22.05 22.05v146.519c0 12.128 9.922 22.05 22.05 22.05h16.049l1.312-.84c-9.265-2.61-16.115-11.139-16.115-21.21z",
  fill: "#4d66d2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m366.021 279.195h61.168c8.297 0 15.085 6.788 15.085 15.085v202.635c0 8.297-6.788 15.085-15.085 15.085h-61.168c-8.297 0-15.085-6.788-15.085-15.085v-202.635c0-8.296 6.788-15.085 15.085-15.085z",
  fill: "#ff636e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m145.979 279.195h-61.168c-8.297 0-15.085 6.788-15.085 15.085v202.635c0 8.297 6.788 15.085 15.085 15.085h61.168c8.297 0 15.085-6.788 15.085-15.085v-202.635c.001-8.296-6.788-15.085-15.085-15.085z",
  fill: "#ff636e"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#ff4654"
}, /*#__PURE__*/React.createElement("path", {
  d: "m388.89 496.916v-202.636c0-8.297 6.788-15.085 15.085-15.085h-37.954c-8.297 0-15.085 6.789-15.085 15.085v202.635c0 8.297 6.788 15.085 15.085 15.085h37.954c-8.297 0-15.085-6.788-15.085-15.084z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m107.681 496.916v-202.636c0-8.297 6.788-15.085 15.085-15.085h-37.955c-8.297 0-15.085 6.789-15.085 15.085v202.635c0 8.297 6.788 15.085 15.085 15.085h37.954c-8.296 0-15.084-6.788-15.084-15.084z"
})));

function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.a7bac569.svg";
export { ForwardRef as ReactComponent };